import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef, MatTableDataSource, MAT_DIALOG_DATA } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CCDAAllergies } from 'src/app/models/IAllergies';
import { CCDAPatientMedication } from 'src/app/models/IPatientMedication';
import { AllergyService } from 'src/app/Services/NewVisitNote/allergy.service';

export interface DialogData {
  PatId: number;
  EncounterId: string;
  Type: string;
}

@Component({
  selector: 'app-reconciliation',
  templateUrl: './reconciliation.component.html',
  styleUrls: ['./reconciliation.component.css']
})

export class ReconciliationComponent implements OnInit {
  patId: number;
  encounterId: string;
  ScreenType: string;
  hederText: string;
  CCDAAllergyList: CCDAAllergies[] = []
  CCDAMedicationList: CCDAPatientMedication[] = []
  mainincompletecheck: boolean = false;
  displayedColumns: string[] = ['checkId', 'allergen', 'reaction', 'severity', 'recordDate'];
  ccdaAllergyDatasource = new MatTableDataSource<CCDAAllergies>()
  medicationColumns: string[] = ['medCheckId', 'medicatioName', 'code', 'status', 'medStartDate', 'dose'];
  ccdaMedicationDatasource = new MatTableDataSource<CCDAPatientMedication>()
  constructor(
    public dialogRef: MatDialogRef<ReconciliationComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private allergyService: AllergyService) {
    this.patId = this.data.PatId;
    this.encounterId = this.data.EncounterId;
    this.ScreenType = this.data.Type;
  }

  ngOnInit() {
    if (this.ScreenType == 'RX') {
      this.hederText = 'Reconciled Medication List'
      this.GetPatCCDAMedications('')
    } else {
      this.hederText = 'Reconciled Allergy List'
      this.GetPatCCDAAllergies('');
    }
  }
  originalArry: CCDAAllergies[] = [];
  originalMedArry: CCDAPatientMedication[] = [];
  ShowAllAllergy(event) {
    this.mainincompletecheck = false;
    if (this.ScreenType == 'RX') {
      if (event.target.checked) {
        return this.GetPatCCDAMedications('All')
      } else {
        return this.GetPatCCDAMedications('')
      }
    } else {
      if (event.target.checked) {
        return this.GetPatCCDAAllergies('All')
      } else {
        return this.GetPatCCDAAllergies('')
      }
    }
  }

  GetPatCCDAAllergies(type: string) {
    this.allergyService.GetPatCCDAAllergies(this.patId, type).subscribe(data => {
      this.CCDAAllergyList = data
      this.originalArry = Object.assign([], this.CCDAAllergyList);
      this.ccdaAllergyDatasource.data = this.CCDAAllergyList;
    });
  }

  selectedCCDAAllergies: CCDAAllergies[] = [];
  selectedCCDAMedications: CCDAPatientMedication[] = [];
  checkAndUncheck(event) {
    if (this.ScreenType == 'RX') {
      this.selectedCCDAMedications = [];
      if (event.checked) {
        this.mainincompletecheck = true;
        this.ccdaMedicationDatasource.data.forEach(element => {
          if (element.linkEncounter == '')
            element.IsSelected = true;
          else
            element.IsSelected = false;
        });
      } else {
        this.ccdaMedicationDatasource.data.forEach(element => {
          element.IsSelected = false;
        });
      }
      var seletmedlist = this.ccdaMedicationDatasource.data.filter(x => x.IsSelected == true);
      this.selectedCCDAMedications = seletmedlist;
    } else {
      this.selectedCCDAAllergies = [];
      if (event.checked) {
        this.mainincompletecheck = true;
        this.ccdaAllergyDatasource.data.forEach(element => {
          if (element.LinkedEncounter == '')
            element.IsSelected = true;
          else
            element.IsSelected = false;
        });
      } else {
        this.ccdaAllergyDatasource.data.forEach(element => {
          element.IsSelected = false;
        });
      }
      var seletlist = this.ccdaAllergyDatasource.data.filter(x => x.IsSelected == true);
      this.selectedCCDAAllergies = seletlist;
    }
  }

  singleCheck(element: any, event) {
    if (this.ScreenType == 'RX') {
      if (event.checked) {
        var medexistlist = this.ccdaMedicationDatasource.data.filter(x => x.ccdapatMedId == element.ccdapatMedId);
        if (medexistlist.length > 0) {
          var index1 = this.ccdaMedicationDatasource.data.findIndex(x => x.ccdapatMedId == element.ccdapatMedId);
          this.ccdaMedicationDatasource.data[index1].IsSelected = true;
        } else {
          var index1 = this.ccdaMedicationDatasource.data.findIndex(x => x.ccdapatMedId == element.ccdapatMedId);
          this.ccdaMedicationDatasource.data[index1].IsSelected = true;
        }
      } else {
        var index1 = this.ccdaMedicationDatasource.data.findIndex(x => x.ccdapatMedId == element.ccdapatMedId);
        this.ccdaMedicationDatasource.data[index1].IsSelected = false;
      }
      var seletlist1 = this.ccdaMedicationDatasource.data.filter(x => x.IsSelected == true);
      var orignalmedlist = this.originalMedArry.filter(x => x.linkEncounter == "");
      if (seletlist1.length == orignalmedlist.length) {
        this.mainincompletecheck = true;
      } else {
        this.mainincompletecheck = false;
      }
      this.selectedCCDAMedications = seletlist1;
    } else {
      if (event.checked) {
        var existlist = this.ccdaAllergyDatasource.data.filter(x => x.CCDAAllergiesId == element.CCDAAllergiesId);
        if (existlist.length > 0) {
          var index1 = this.ccdaAllergyDatasource.data.findIndex(x => x.CCDAAllergiesId == element.CCDAAllergiesId);
          this.ccdaAllergyDatasource.data[index1].IsSelected = true;
        } else {
          var index1 = this.ccdaAllergyDatasource.data.findIndex(x => x.CCDAAllergiesId == element.CCDAAllergiesId);
          this.ccdaAllergyDatasource.data[index1].IsSelected = true;
        }
      } else {
        var index1 = this.ccdaAllergyDatasource.data.findIndex(x => x.CCDAAllergiesId == element.CCDAAllergiesId);
        this.ccdaAllergyDatasource.data[index1].IsSelected = false;
      }
      var seletlist = this.ccdaAllergyDatasource.data.filter(x => x.IsSelected == true);
      var orignallist = this.originalArry.filter(x => x.LinkedEncounter == "");
      if (seletlist.length == orignallist.length) {
        this.mainincompletecheck = true;
      } else {
        this.mainincompletecheck = false;
      }
      this.selectedCCDAAllergies = seletlist;
    }
  }
  onNoClick() {
    this.dialogRef.close();
  }
  SaveCCDAAllergies() {
    if (this.selectedCCDAAllergies.length == 0) {
      this.toastr.warning("Please select at least one row");
      return
    }
    this.dialogRef.close(this.selectedCCDAAllergies);
  }

  GetPatCCDAMedications(type: string) {
    this.allergyService.GetPatCCDAMedication(this.patId, type).subscribe(data => {
      this.CCDAMedicationList = data
      this.originalMedArry = Object.assign([], this.CCDAMedicationList);
      this.ccdaMedicationDatasource.data = this.CCDAMedicationList;
    });
  }

  SaveCCDAMedication() {
    if (this.selectedCCDAMedications.length == 0) {
      this.toastr.warning("Please select at least one row");
      return
    }
    this.dialogRef.close(this.selectedCCDAMedications);
  }
}
